import { Get } from "../http/httpVerbs";

export const apiGetDesafios = async (params = {}) => {
    try {
        const { comunidade } = params;
        let url = `${process.env.REACT_APP_API_URL}/desafios`;

        const response = await Get(url);

        const currentDate = new Date();
        const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

        let filteredDesafios = response.filter((desafio) => {
            if (!desafio.data_inicio || !desafio.data_fim) return false;

            const [anoInicio, mesInicio, diaInicio] = desafio.data_inicio.split("-");
            const [anoFim, mesFim, diaFim] = desafio.data_fim.split("-");

            const data_inicio = new Date(parseInt(anoInicio), parseInt(mesInicio) - 1, parseInt(diaInicio));

            const data_fim = new Date(parseInt(anoFim), parseInt(mesFim) - 1, parseInt(diaFim));
            data_fim.setHours(23, 59, 59, 999);

            return data_inicio <= today && data_fim >= today;
        });

        if (comunidade) {
            filteredDesafios = filteredDesafios.filter((desafio) => desafio.comunidade === Number(comunidade));
        }

        return filteredDesafios;
    } catch (error) {
        console.error("API apiGetDesafios ERROR:", error);
        throw error;
    }
};
